import { _ } from "../../../core/polyglot/polyglot.js";
import { formatForceTwoDecimals } from "../../../core/helpers/count-formatting-util.js";
import Model from "../../Model.js";
import ReportRow from "./ReportRow.js";

/**
 * `InvoiceReportData` represents the data generated from a company's invoice records
 *
 * @param {ReportRow[]} spec.rows - The list of all the rows excluding the summary row.
 * Each row contains the values for every column and a reference to the owner of those values.
 * @param {number[]} spec.summaryRowCells - This contains cell values for the last row
 * of the table. This last row has the summed up values for each column.
 */
export default class InvoiceReportData extends Model {
	constructor({ rows = [], summaryRowCells = [] }) {
		super(...arguments);
		this._reportRows = rows;
		this._summaryRowCells = summaryRowCells;
	}

	getReportRows() {
		return this._reportRows;
	}

	getRowData() {
		return this._reportRows?.map((reportRow) => reportRow.getData());
	}

	getSummaryRowData() {
		return (
			this._summaryRowCells &&
			((html) =>
				html.tr(
					html.th(_("Total")),
					this._summaryRowCells.map((cell) =>
						html.td(
							{ class: "text-right" },
							formatForceTwoDecimals(cell || 0),
						),
					),
				))
		);
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.rows = ReportRow.materializeAll(data.rows, context);
		data.summaryRowCells = data.summaryRow.map((cell) => cell.value);
	}
}
